var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRolesModal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "253px",
    height: "89px",
    viewBox: "0 0 253 89",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 1932") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M62.5739,1.78515 C57.893,0.70485 50.1986,0 41.5,0 C32.8014,0 25.107,0.70485 20.4261,1.78515 C11.0932,3.7436 3.7436,11.0932 1.78515,20.4261 C0.70485,25.107 0,32.8014 0,41.5 C0,50.1986 0.70485,57.893 1.78515,62.5739 C3.7436,71.9068 11.0932,79.2564 20.4261,81.2148 C25.107,82.2952 32.8014,83 41.5,83 C50.1986,83 57.893,82.2952 62.5739,81.2148 C71.9068,79.2564 79.2564,71.9068 81.2148,62.5739 C82.2952,57.893 83,50.1986 83,41.5 C83,32.8014 82.2952,25.107 81.2148,20.4261 C79.2564,11.0932 71.9068,3.7436 62.5739,1.78515 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.15968,3.614 C15.28118,27.1128 7.64758,70.225 -1.77635684e-15,113.707 L26.92488,113.707 C30.55408,82.834 35.33178,51.549 41.96898,19.5976 C45.67598,43.295 53.08138,76.747 61.21888,112.131 L87.07188,110.273 L60.82198,0",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33540334,51.2571 C18.9892733,58.7619 33.7624733,24.6451 33.7624733,24.6451 C33.7624733,24.6451 44.3720733,5.8747 36.1800733,7.3407 C27.9878733,8.8067 11.6772833,37.2628 11.6772833,37.2628 L18.3176733,2.5525 L8.54353334,0 C8.54353334,0 -8.31852666,43.7524 5.33540334,51.2571 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2012763,1.1219 C-2.50962367,3.6464 0.253776332,37 0.253776332,37 L33.6181763,47.7184 L66.9824763,33.4368 C66.9824763,33.4368 48.8866763,1.7595 37.6955763,1.1219 C37.6955763,1.1219 31.1256763,0 22.9786763,0 C18.9057763,0 14.4379763,0.2805 10.2012763,1.1219 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9298,10.0303 C13.9298,15.5698 10.8116,20.0603 6.9649,20.0603 C3.1183,20.0603 0,15.5698 0,10.0303 C0,4.4908 3.1183,-1.77635684e-15 6.9649,-1.77635684e-15 C10.8116,-1.77635684e-15 13.9298,4.4908 13.9298,10.0303 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9298,10.0303 C13.9298,15.5698 10.8116,20.0603 6.9649,20.0603 C3.1183,20.0603 0,15.5698 0,10.0303 C0,4.4908 3.1183,-1.77635684e-15 6.9649,-1.77635684e-15 C10.8116,-1.77635684e-15 13.9298,4.4908 13.9298,10.0303 Z",
    id: "path-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.574,1.78515 C57.893,0.70485 50.199,0 41.5,0 C32.801,0 25.107,0.70485 20.426,1.78515 C11.093,3.7436 3.744,11.0932 1.785,20.4261 C0.705,25.107 0,32.8014 0,41.5 C0,50.1986 0.705,57.893 1.785,62.5739 C3.744,71.9068 11.093,79.2564 20.426,81.2148 C25.107,82.2952 32.801,83 41.5,83 C50.199,83 57.893,82.2952 62.574,81.2148 C71.907,79.2564 79.256,71.9068 81.215,62.5739 C82.295,57.893 83,50.1986 83,41.5 C83,32.8014 82.295,25.107 81.215,20.4261 C79.256,11.0932 71.907,3.7436 62.574,1.78515 Z",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.578559,0 L7.16555895,1.6323 C7.14955895,1.633 7.13555895,1.6431 7.13155895,1.6586 C7.01955895,2.0545 5.62255895,7.0721 5.45555895,11.4441 C5.28055895,15.999 4.45755895,30.6212 2.84255895,38.6792 C1.22755895,46.7372 -0.641441049,62.2482 1.62355895,74.2692 C3.82555895,85.9622 0.199558951,104.9222 0,105.9442 C-0.00344104865,105.9672 0.0145589514,105.9872 0.0375589514,105.9872 C0.0375589514,105.9872 27.573559,106.0172 27.574559,105.9982 C27.653559,104.8472 26.529559,95.9432 27.923559,91.9142 C28.460559,90.3612 30.697559,81.7152 30.755559,76.8682 C30.813559,72.0212 27.802559,66.0432 28.097559,60.9642 C28.334559,56.8902 31.928559,40.7282 32.596559,37.0372 C32.604559,36.9922 32.672559,36.9992 32.670559,37.0462 C32.515559,41.0412 28.735559,60.2632 31.248559,65.9862 C34.431559,73.2332 35.580559,85.8042 34.948559,91.2132 C34.135559,98.1622 37.823559,105.4412 38.016559,105.9632 C38.021559,105.9782 38.035559,105.9872 38.050559,105.9872 C38.050559,105.9872 63.809559,106.0112 63.8025604,105.9872 C63.376559,104.5582 60.440559,96.3962 58.229559,83.4362 C56.487559,73.2272 56.603559,58.2782 55.732559,54.0152 C55.099559,50.9172 53.120559,42.2772 51.900559,39.7082 C50.681559,37.1382 48.301559,27.8532 48.127559,23.1817 C47.952559,18.51 46.385559,12.2032 44.991559,9.1083 C43.657559,6.1437 42.695559,0.5006 42.616559,0.0298 C42.613559,0.0118 42.598559,0 42.580559,0 C42.579559,0 42.579559,0 42.578559,0 Z",
    id: "path-15"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-17",
    points: "0 11.2121 2.399 22.1523 20.146 8.4091 12.947 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-19",
    points: "0 11.2121 2.399 22.1523 20.146 8.4091 12.947 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6116098,8.98138 C8.6116098,8.98138 6.2316098,-0.36212 4.1996098,0.22196 C2.1676098,0.80587 5.0126098,12.19308 5.0126098,12.19308 C5.0126098,12.19308 0.483609795,8.74768 0.0196097952,11.08368 C-0.445390205,13.41948 7.5086098,19.60938 8.0316098,21.30288 C8.5536098,22.99628 19.7336098,62.58888 19.7336098,62.58888 L11.7356098,51.91558 C11.6856098,51.93968 11.6346098,51.96518 11.5836098,51.99128 C8.4216098,53.59338 4.7126098,57.37178 4.6746098,60.56728 C6.8076098,63.37058 10.0636098,67.29608 14.3596098,71.46518 C22.6036098,79.46538 35.1436098,71.99078 31.2546098,59.01418 C27.3646098,46.03778 21.3266098,25.79928 20.6876098,24.04758 C20.0486098,22.29568 20.3396098,19.08398 20.0486098,17.85748 C19.7586098,16.63118 16.1596098,9.91568 16.1596098,9.91568 C16.1596098,9.91568 15.2306098,2.03219 13.9536098,2.14904 C12.6756098,2.26571 12.8496098,8.98138 12.8496098,8.98138 C12.8496098,8.98138 11.1296098,1.21984 9.6796098,0.0706 C9.4916098,0.04695 9.3036098,0.02347 9.1146098,-8.8817842e-16 C7.8716098,0.84791 8.6116098,8.98138 8.6116098,8.98138 Z",
    id: "path-21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6116098,8.98138 C8.6116098,8.98138 6.2316098,-0.36212 4.1996098,0.22196 C2.1676098,0.80587 5.0126098,12.19308 5.0126098,12.19308 C5.0126098,12.19308 0.483609795,8.74768 0.0196097952,11.08368 C-0.445390205,13.41948 7.5086098,19.60938 8.0316098,21.30288 C8.5536098,22.99628 19.7336098,62.58888 19.7336098,62.58888 L11.7356098,51.91558 C11.6856098,51.93968 11.6346098,51.96518 11.5836098,51.99128 C8.4216098,53.59338 4.7126098,57.37178 4.6746098,60.56728 C6.8076098,63.37058 10.0636098,67.29608 14.3596098,71.46518 C22.6036098,79.46538 35.1436098,71.99078 31.2546098,59.01418 C27.3646098,46.03778 21.3266098,25.79928 20.6876098,24.04758 C20.0486098,22.29568 20.3396098,19.08398 20.0486098,17.85748 C19.7586098,16.63118 16.1596098,9.91568 16.1596098,9.91568 C16.1596098,9.91568 15.2306098,2.03219 13.9536098,2.14904 C12.6756098,2.26571 12.8496098,8.98138 12.8496098,8.98138 C12.8496098,8.98138 11.1296098,1.21984 9.6796098,0.0706 C9.4916098,0.04695 9.3036098,0.02347 9.1146098,-8.8817842e-16 C7.8716098,0.84791 8.6116098,8.98138 8.6116098,8.98138 Z",
    id: "path-23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6116098,8.98138 C8.6116098,8.98138 6.2316098,-0.36212 4.1996098,0.22196 C2.1676098,0.80587 5.0126098,12.19308 5.0126098,12.19308 C5.0126098,12.19308 0.483609795,8.74768 0.0196097952,11.08368 C-0.445390205,13.41948 7.5086098,19.60938 8.0316098,21.30288 C8.5536098,22.99628 19.7336098,62.58888 19.7336098,62.58888 L11.7356098,51.91558 C11.6856098,51.93968 11.6346098,51.96518 11.5836098,51.99128 C8.4216098,53.59338 4.7126098,57.37178 4.6746098,60.56728 C6.8076098,63.37058 10.0636098,67.29608 14.3596098,71.46518 C22.6036098,79.46538 35.1436098,71.99078 31.2546098,59.01418 C27.3646098,46.03778 21.3266098,25.79928 20.6876098,24.04758 C20.0486098,22.29568 20.3396098,19.08398 20.0486098,17.85748 C19.7586098,16.63118 16.1596098,9.91568 16.1596098,9.91568 C16.1596098,9.91568 15.2306098,2.03219 13.9536098,2.14904 C12.6756098,2.26571 12.8496098,8.98138 12.8496098,8.98138 C12.8496098,8.98138 11.1296098,1.21984 9.6796098,0.0706 C9.4916098,0.04695 9.3036098,0.02347 9.1146098,-8.8817842e-16 C7.8716098,0.84791 8.6116098,8.98138 8.6116098,8.98138 Z",
    id: "path-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.336,3.3454 C8.37,6.3236 -2.84217094e-14,15.9006 -2.84217094e-14,15.9006 C1.582,18.9405 5.13,23.0487 9.24,27.4631 L15.685,21.6818 L13.537,35.3465 L49.01,33.7115 C49.01,33.7115 46.223,22.4411 46.745,21.39 C47.268,20.3387 48.835,18.1781 47.152,14.2656 C45.468,10.3531 42.061,0.2932 36.382,0.0462 C35.702,0.0166 34.962,0 34.175,0 C28.87,0 21.403,0.7521 15.336,3.3454 Z",
    id: "path-27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.574,1.78515 C57.893,0.70485 50.199,0 41.5,0 C32.801,0 25.107,0.70485 20.426,1.78515 C11.0932,3.7436 3.7436,11.0932 1.7852,20.4261 C0.7048,25.107 0,32.8014 0,41.5 C0,50.1986 0.7048,57.893 1.7852,62.5739 C3.7436,71.9068 11.0932,79.2564 20.426,81.2148 C25.107,82.2952 32.801,83 41.5,83 C50.199,83 57.893,82.2952 62.574,81.2148 C71.907,79.2564 79.256,71.9068 81.215,62.5739 C82.295,57.893 83,50.1986 83,41.5 C83,32.8014 82.295,25.107 81.215,20.4261 C79.256,11.0932 71.907,3.7436 62.574,1.78515 Z",
    id: "path-29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.42108547e-14,9.5186 C1.42108547e-14,14.7754 3.015,19.0371 6.735,19.0371 C10.454,19.0371 13.47,14.7754 13.47,9.5186 C13.47,4.2615 10.454,0 6.735,0 C3.015,0 1.42108547e-14,4.2615 1.42108547e-14,9.5186 Z",
    id: "path-31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.42108547e-14,9.5186 C1.42108547e-14,14.7754 3.015,19.0371 6.735,19.0371 C10.454,19.0371 13.47,14.7754 13.47,9.5186 C13.47,4.2615 10.454,0 6.735,0 C3.015,0 1.42108547e-14,4.2615 1.42108547e-14,9.5186 Z",
    id: "path-33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5573114,50.609875 C25.5573114,50.609875 6.58531142,52.713375 3.10831142,54.035675 C-0.368688582,55.358175 0.0123114182,84.901175 0.0123114182,84.901175 L35.4943114,83.856675 L32.8013114,61.401875 L54.5143114,3.881825 C51.9743114,1.333535 48.4863114,0.24141 44.4453114,0 C36.5083114,19.715075 29.2193114,38.307575 25.5573114,50.609875 Z",
    id: "path-35"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-1932",
    transform: "translate(1.703120, 1.703120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.14988,1.81548 C59.33188,0.70543 51.53338,0 42.79688,0 C34.06038,0 26.26188,0.70543 21.44388,1.81548 C11.61758,3.88273 3.88273,11.61758 1.81548,21.44388 C0.70543,26.26188 0,34.06038 0,42.79688 C0,51.53338 0.70543,59.33188 1.81548,64.14988 C3.88272,73.97608 11.61748,81.71088 21.44368,83.77828 C26.26168,84.88828 34.06028,85.59378 42.79688,85.59378 C51.53348,85.59378 59.33208,84.88828 64.15008,83.77828 C73.97618,81.71098 81.71098,73.97618 83.77828,64.15008 C84.88828,59.33208 85.59378,51.53348 85.59378,42.79688 C85.59378,34.06028 84.88828,26.26168 83.77828,21.44368 C81.71088,11.61748 73.97608,3.88272 64.14988,1.81548 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2.59375,
    fill: "#E4E1FA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(1.296880, 1.296880)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.976573, 5.999986)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(7.088393, 62.417014)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, -1.576400)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.15968,5.1904 L60.82208,1.5764 L87.07188,111.8494 L61.21888,113.7074 C53.08138,78.3234 45.67608,44.8714 41.96918,21.174 C35.33178,53.1254 30.55388,84.4104 26.92488,115.2834 L-1.77635684e-15,115.2834 C7.64778,71.8014 15.28118,28.6892 22.15968,5.1904 Z",
    stroke: "none",
    fill: "#FEE4A8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.23978,16.2973 C26.17728,14.3641 30.40658,9.5547 30.55068,1.5769 L52.93418,0 C56.13588,7.4187 60.93278,11.1345 66.44818,13.1823",
    stroke: "#FCBB26",
    strokeWidth: 1.05627,
    fill: "none",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.92068,
    y1: 8.6789,
    x2: 63.56858,
    y2: 4.239,
    stroke: "#FCBB26",
    strokeWidth: 1.05627,
    fill: "none",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.74508,
    y1: 2.1501,
    x2: 67.03858,
    y2: 115.2834,
    stroke: "#FCBB26",
    strokeWidth: 1.05627,
    fill: "none",
    strokeLinejoin: "bevel"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M46.1220733,96.7280137 L49.4355733,80.3280137 L52.4028733,78.9547137 C56.0460733,77.6908137 54.5388733,70.5514137 52.7540733,63.4800137",
    id: "Path",
    stroke: "#FCBB26",
    strokeWidth: 1.05627,
    fill: "none",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9862733,28.3571137 L8.21818334,27.0302137 L8.28675334,26.7910137 C10.1161933,20.4054137 13.0560533,8.58841369 14.1471733,8.50401369 C15.2383733,8.41971369 15.3213733,12.7904137 14.8528733,14.6252137 C15.6937733,12.1888137 16.4633733,7.65971369 17.6135733,7.74421369 C18.7637733,7.82861369 18.3296733,12.7789137 17.6135733,15.0872137 C18.3834733,12.7603137 20.2273733,8.60771369 21.5520733,8.85141369 C22.8767733,9.09511369 20.8237733,15.4542137 19.6453733,18.3831137 C21.5520733,17.9600137 23.8561733,16.3229137 24.3876733,17.6223137 C25.0519733,19.2466137 19.4736733,22.9510137 18.7266733,23.9368137 C18.1290733,24.7255137 17.3172733,27.2123137 16.9862733,28.3571137 Z",
    id: "Path",
    stroke: "none",
    fill: "#F2CBB9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9367233,20.3961137 C15.3763733,19.0316137 16.2673733,18.6449137 18.0277733,18.7250137",
    id: "Path",
    stroke: "#ECA789",
    strokeWidth: 0.885352,
    fill: "none",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-0.000000, 23.728514)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000015, 0.000000)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.762458,24.6453 C33.762458,24.6453 18.989258,58.7619 5.33535799,51.2573 C-8.31854201,43.7524 8.54364799,0 8.54364799,0 L18.317758,2.5525 L11.677408,37.2628 C11.677408,37.2628 27.987758,8.8069 36.180058,7.3407 C44.372258,5.8747 33.762458,24.6453 33.762458,24.6453 Z",
    stroke: "none",
    fill: "#006C5B",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.83861799,
    y1: 4.0213,
    x2: 18.009658,
    y2: 8.0738,
    stroke: "#004736",
    strokeWidth: 1.05627,
    fill: "none",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.709058,0.3621 L6.21019799,46.2584 C6.21019799,46.2584 30.183658,15.8322 33.541258,15.6069",
    stroke: "#004736",
    strokeWidth: 1.05627,
    fill: "none",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.042358,4.5553 C16.965158,4.8777 16.764358,5.1055 16.594158,5.0643 C16.423958,5.0229 16.348558,4.7281 16.425958,4.4057 C16.503158,4.0835 16.703758,3.8556 16.873958,3.897 C17.044158,3.9382 17.119558,4.233 17.042358,4.5553 Z",
    stroke: "#A8ABBC",
    strokeWidth: 1.05627,
    fill: "none",
    strokeLinejoin: "bevel"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(28.999997, 29.000014)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.039101, -1.806900)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.535175,2.4447 C39.600475,3.0914 38.867875,35.2209 38.867875,35.2209 L0.205575035,38.8351 C0.205575035,38.8351 -2.03292496,5.0052 8.26347504,2.4447 C18.559975,-0.1159 30.535175,2.4447 30.535175,2.4447 Z",
    stroke: "none",
    fill: "#006C5B",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polyline", {
    stroke: "#004736",
    strokeWidth: 1.05627,
    fill: "none",
    points: "10.632275 0 17.080075 6.344 20.393675 1.337 23.149475 6.9794 28.857375 0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.961275,
    y1: 36.8995,
    x2: 20.395475,
    y2: 1.3381,
    stroke: "#004736",
    strokeWidth: 1.05627,
    fill: "none",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.671375,19.1708 L63.932275,43.7662 L67.101675,32.8656 C67.101675,32.8656 39.343575,4.3932 30.814775,2.045 C22.285875,-0.3034 29.892475,15.4014 34.671375,19.1708 Z",
    stroke: "none",
    fill: "#006C5B",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M56.9041733,15.2665137 C61.3517733,12.3383137 59.9973733,7.77751369 56.9041733,9.24251369 C56.6792733,-0.832466306 52.0906733,-0.860656306 49.8523733,3.97991369 C47.8937733,-2.88693631 44.3683733,0.0680536943 44.9839733,5.78111369 C41.2345733,2.99501369 38.7478733,3.89531369 41.3745733,9.46781369 C38.1288733,9.46781369 38.8564733,13.0418137 43.1349733,14.9853137 L56.9041733,15.2665137 Z",
    id: "Path",
    stroke: "none",
    fill: "#843628",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(43.039973, 6.611814)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.001,10.0323 C-0.001,15.5718 3.1174,20.0624 6.9639,20.0624 C10.8105,20.0624 13.9288,15.5718 13.9288,10.0323 C13.9288,4.4928 10.8105,0.0022 6.9639,0.0022 C3.1174,0.0022 -0.001,4.4928 -0.001,10.0323 Z",
    id: "Path",
    fill: "#F2CBB9",
    mask: "url(#mask-10)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(43.039973, 6.611814)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5213,8.9321 C13.9595,9.1445 11.8743,8.3735 11.1493,4.7943 C8.3671,5.9901 5.5993,5.7059 2.8465,3.8936 C2.7506,5.7475 0.5172,8.7317 -2.5046,10.0288 L-1.9451,-4.324 L13.2758,-4.324 L16.5213,8.9321 Z",
    id: "Path",
    fill: "#843628",
    mask: "url(#mask-12)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.7460733,21.5013137 C47.6134733,23.7246137 51.0828733,23.8371137 51.7543733,21.1636137",
    id: "Path",
    stroke: "#ECA789",
    strokeWidth: 1.05627,
    fill: "none",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5232733,36.9451137 C29.6220733,43.1434137 29.0095733,51.6237137 29.0443733,58.0020137",
    id: "Path",
    stroke: "#004736",
    strokeWidth: 1.05627,
    fill: "none",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7287733,38.2854137 C66.7128733,41.8949137 67.2847733,46.8182137 67.6698733,52.3365137",
    id: "Path",
    stroke: "#004736",
    strokeWidth: 1.05627,
    fill: "none",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9372733,39.4475137 L53.4231733,39.9912137 C53.4231733,39.9912137 53.0874733,49.5272137 58.5714733,49.7136137 C64.0553733,49.9001137 62.9372733,39.4475137 62.9372733,39.4475137 Z",
    id: "Path",
    stroke: "#004736",
    strokeWidth: 1.05627,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M228.14988,1.81548 C223.33188,0.70543 215.53288,0 206.79688,0 C198.06088,0 190.26188,0.70543 185.44388,1.81548 C175.61788,3.88273 167.88288,11.61758 165.81588,21.44388 C164.70588,26.26188 163.99988,34.06038 163.99988,42.79688 C163.99988,51.53338 164.70588,59.33188 165.81588,64.14988 C167.88288,73.97608 175.61788,81.71088 185.44388,83.77828 C190.26188,84.88828 198.05988,85.59378 206.79688,85.59378 C215.53388,85.59378 223.33188,84.88828 228.14988,83.77828 C237.97588,81.71098 245.71088,73.97618 247.77788,64.15008 C248.88788,59.33208 249.59388,51.53348 249.59388,42.79688 C249.59388,34.06028 248.88788,26.26168 247.77788,21.44368 C245.71088,11.61748 237.97588,3.88272 228.14988,1.81548 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2.59375,
    fill: "#FEE4A8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(165.296880, 1.296880)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-14)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.123000, 4.101320)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(15.040441, 69.540480)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, -0.819500)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.16555895,2.4518 L42.578559,0.8195 C42.597559,0.8195 42.613559,0.8306 42.616559,0.8494 C42.695559,1.3201 43.657559,6.9633 44.992559,9.9278 C46.385559,13.0227 47.953559,19.3295 48.127559,24.0012 C48.301559,28.6727 50.681559,37.9577 51.900559,40.5277 C53.120559,43.0967 55.099559,51.7367 55.732559,54.8347 C56.603559,59.0977 56.487559,74.0467 58.228559,84.2557 C60.440559,97.2157 63.376559,105.3777 63.8025604,106.8067 C63.809559,106.8307 38.050559,106.8067 38.050559,106.8067 C38.035559,106.8067 38.021559,106.7977 38.016559,106.7827 C37.823559,106.2607 34.135559,98.9817 34.948559,92.0327 C35.580559,86.6237 34.431559,74.0527 31.248559,66.8057 C28.735559,61.0827 32.515559,41.8607 32.670559,37.8657 C32.672559,37.8187 32.604559,37.8117 32.596559,37.8567 C31.928559,41.5477 28.334559,57.7097 28.097559,61.7837 C27.802559,66.8627 30.813559,72.8407 30.755559,77.6877 C30.697559,82.5347 28.460559,91.1807 27.923559,92.7337 C26.529559,96.7627 27.653559,105.6667 27.574559,106.8177 C27.573559,106.8367 0.0375589514,106.8067 0.0375589514,106.8067 C0.0145589514,106.8067 -0.00344104865,106.7867 0,106.7637 C0.199558951,105.7417 3.82655895,86.7817 1.62355895,75.0877 C-0.640441049,63.0677 1.22755895,47.5567 2.84255895,39.4987 C4.45755895,31.4407 5.28055895,16.8185 5.45555895,12.2636 C5.62255895,7.8916 7.01955895,2.8739 7.13155895,2.4779 C7.13555895,2.4627 7.14955895,2.4525 7.16555895,2.4518 Z",
    stroke: "none",
    fill: "#D3E2F6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.768559,
    y1: 1.9194,
    x2: 5.10555895,
    y2: 106.8057,
    stroke: "#83B2EE",
    strokeWidth: 1.05627,
    fill: "none",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.45155895,
    y1: 4.033,
    x2: 43.232559,
    y2: 3.1909,
    stroke: "#83B2EE",
    strokeWidth: 1.05627,
    fill: "none",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.221559,12.0268 C15.348559,10.2119 18.795559,4.8492 20.140559,1.42108547e-14",
    stroke: "#83B2EE",
    strokeWidth: 1.05627,
    fill: "none",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.066559,0.2339 C39.997559,4.0479 42.782559,8.1368 45.598559,8.7934",
    stroke: "#83B2EE",
    strokeWidth: 1.05627,
    fill: "none",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.970559,1.4554 L30.184559,13.6075 C30.184559,13.6075 33.883559,11.6309 33.572559,8.7944 C33.261559,5.9576 32.759559,1.2807 32.759559,1.2807",
    stroke: "#83B2EE",
    strokeWidth: 1.05627,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0.000000, 51.143280)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#AE5848",
    mask: "url(#mask-18)",
    points: "2.398 22.1521 20.145 8.4091 12.946 0 -0.001 11.2121"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0.000000, 51.143280)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-20",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.817,2.3567 C10.013,5.0653 13.022,9.1452 16.361,13.4734 L18.833,8.9282 L11.814,0.8306 L8.817,2.3567 Z",
    id: "Path",
    fill: "#843628",
    mask: "url(#mask-20)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.275,64.15118 C55.161,64.15118 55.049,64.14558 54.938,64.13418 C54.161,64.05418 53.131,63.65238 52.632,62.19328 C51.961,60.22888 52.575,57.93588 54.406,55.56208 C55.832,53.71448 57.947,51.94388 59.927,50.94088 C61.837,49.97278 63.222,49.92568 63.825,50.80828 C65.124,52.70908 64.934,55.29118 63.291,58.07898 C61.51,61.09848 57.943,64.15098 55.275,64.15118 Z",
    id: "Path",
    stroke: "none",
    fill: "#FF9D88",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.228,63.27148 L63.825,50.81038 C63.825,50.81038 55.114,38.87198 51.092,37.05558 C47.069,35.23938 40.296,35.90968 40.296,35.90968 L53.228,63.27148 Z",
    id: "Path",
    stroke: "none",
    fill: "#FF9D88",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.452,51.35258 C62.068,51.35258 61.416,51.49918 60.452,51.98758 C56.867,53.80448 52.578,58.42018 53.736,61.81038 C53.979,62.52118 54.411,62.89908 55.057,62.96558 C57.029,63.16828 60.475,60.55358 62.288,57.47908 C63.098,56.10558 64.249,53.49878 62.864,51.47198 C62.82,51.40718 62.686,51.35258 62.452,51.35258 Z",
    id: "Path",
    stroke: "none",
    fill: "#FCDBD4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(48.867390, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-22",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0606098,49.68608 L19.7306098,62.59168 C19.7306098,62.59168 8.5506098,22.99908 8.0286098,21.30548 C7.5056098,19.61218 -0.448390205,13.42198 0.0166097952,11.08628 C0.480609795,8.75048 5.0096098,12.19568 5.0096098,12.19568 C5.0096098,12.19568 2.1646098,0.80844 4.1966098,0.22454 C6.2286098,-0.35937 8.6086098,8.98398 8.6086098,8.98398 C8.6086098,8.98398 7.7966098,0.04935 9.3056098,-0.0675 C10.8146098,-0.18418 12.8466098,8.98398 12.8466098,8.98398 C12.8466098,8.98398 12.6726098,2.26846 13.9506098,2.15161 C15.2276098,2.03476 16.1566098,9.91828 16.1566098,9.91828 C16.1566098,9.91828 19.7556098,16.63398 20.0466098,17.86028 C20.3366098,19.08658 20.0466098,22.29828 20.6846098,24.05018 C21.3236098,25.80208 27.3616098,46.04038 31.2516098,59.01698 C35.1406098,71.99348 22.6006098,79.46818 14.3566098,71.46798 C6.1126098,63.46758 1.6996098,56.36568 1.6996098,56.36568 L10.0606098,49.68608 Z",
    id: "Path",
    fill: "#AE5848",
    mask: "url(#mask-22)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(48.867390, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-24",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6096098,12.93578 C10.7446098,13.37548 12.5516098,14.41488 13.7766098,16.51508 C13.7966098,15.15758 14.0316098,13.89578 14.9376098,12.93578",
    id: "Path",
    stroke: "#843628",
    strokeWidth: 1.05627,
    strokeLinejoin: "bevel",
    mask: "url(#mask-24)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(48.867390, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-26",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2216098,60.79258 C8.5946098,56.52358 10.8366098,54.20568 13.7966098,53.50038 L10.8936098,50.29368 L4.5076098,55.13438 L7.2216098,60.79258 Z",
    id: "Path",
    fill: "#843628",
    mask: "url(#mask-26)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.816,51.72788 C10.398,54.76778 13.946,58.87598 18.056,63.29038 L24.5,57.50908 L22.352,71.17388 L57.825,69.53878 C57.825,69.53878 55.038,58.26818 55.561,57.21708 C56.083,56.16598 57.651,54.00538 55.967,50.09288 C54.284,46.18018 50.876,36.12048 45.198,35.87328 C39.934,35.64438 31.119,36.19458 24.152,39.17268 C17.185,42.15088 8.816,51.72788 8.816,51.72788 Z",
    id: "Path",
    stroke: "none",
    fill: "#01B388",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(8.817000, 35.827180)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-28",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-28)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, -1.385000)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.84217094e-14,17.2852 C1.582,20.3251 5.13,24.4333 9.24,28.8477 L15.685,23.0664 L13.537,36.7312 L49.01,35.0961 C49.01,35.0961 46.223,23.8255 46.745,22.7744 C47.268,21.7233 48.835,19.5627 47.152,15.6502 C45.468,11.7375 42.061,1.6778 36.382,1.4306 C31.118,1.2017 22.303,1.7519 15.336,4.73 C8.37,7.7082 -2.84217094e-14,17.2852 -2.84217094e-14,17.2852 Z",
    stroke: "none",
    fill: "#FF9D88",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.664,0.6424 C21.664,0.6424 22.921,3.6462 25.187,5.7439 C26.364,6.8341 27.814,7.6795 29.502,7.7315 C34.436,7.8834 36.875,7.10542736e-15 36.875,7.10542736e-15",
    stroke: "#FCDBD4",
    strokeWidth: 1.05627,
    fill: "none",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.714,
    y1: 0.6435,
    x2: 25.186,
    y2: 5.745,
    stroke: "#FCDBD4",
    strokeWidth: 1.05627,
    fill: "none",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.63,
    y1: 0.3505,
    x2: 28.388,
    y2: 7.5778,
    stroke: "#FCDBD4",
    strokeWidth: 1.05627,
    fill: "none",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.373,
    y1: 0.6435,
    x2: 31.961,
    y2: 7.1052,
    stroke: "#FCDBD4",
    strokeWidth: 1.05627,
    fill: "none",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.961,
    y1: 0.3505,
    x2: 34.38,
    y2: 4.8783,
    stroke: "#FCDBD4",
    strokeWidth: 1.05627,
    fill: "none",
    strokeLinejoin: "bevel"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M43.429,24.21128 C43.429,29.45398 40.62,33.70408 37.155,33.70408 C33.691,33.70408 30.882,29.45398 30.882,24.21128 C30.882,18.96858 33.691,14.71848 37.155,14.71848 C40.62,14.71848 43.429,18.96858 43.429,24.21128 Z",
    id: "Path",
    stroke: "none",
    fill: "#AE5848",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.477,12.92398 C42.21,13.00608 44.354,11.59728 46.183,9.39088 C46.183,9.39088 42.765,8.70858 41.712,9.53698 C39.757,11.07548 39.249,13.00418 39.477,12.92398 Z",
    id: "Path",
    stroke: "none",
    fill: "#01B388",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.668,4.57198 C41.32,4.65958 39.854,5.79838 39.615,7.49188 C39.375,9.18528 39.433,12.16348 39.433,12.16348 C39.433,12.16348 42.253,10.03208 42.512,7.49188 C42.771,4.95168 41.668,4.57198 41.668,4.57198 Z",
    id: "Path",
    stroke: "none",
    fill: "#D69702",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.203,15.78348 C37.203,15.78348 40.09,19.49168 43.195,20.68878 C43.195,16.57178 39.362,14.20678 39.362,14.20678 L37.203,15.78348 Z",
    id: "Path",
    stroke: "none",
    fill: "#D69702",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.654,13.65538 C35.884,13.71888 34.501,14.52248 32.451,17.02758 C30.401,19.53248 30.093,24.25598 30.784,25.79858 C32.828,25.98368 39.033,17.85908 39.423,14.70288 C39.813,11.54668 37.654,13.65538 37.654,13.65538 Z",
    id: "Path",
    stroke: "none",
    fill: "#FCBB26",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.825,10.96668 C35.972,11.70228 36.228,15.08358 37.448,15.69678 C38.667,16.30988 41.076,16.10548 41.25,13.53618 C41.425,10.96668 38.928,10.52868 37.825,10.96668 Z",
    id: "Path",
    stroke: "#D69702",
    strokeWidth: 1.05627,
    fill: "#01B388",
    fillRule: "evenodd",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.392,26.64578 L36.109,26.23708 C36.109,26.23708 36.689,28.80638 38.75,28.98158 C40.811,29.15678 41.392,26.64578 41.392,26.64578 Z",
    id: "Path",
    stroke: "#843628",
    strokeWidth: 1.05627,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.472,46.64528 C54.472,46.64528 56.884,51.38748 56.718,53.13858 C56.553,54.88968 55.498,57.56718 55.498,57.56718 L57.24,67.08488",
    id: "Path",
    stroke: "#FCDBD4",
    strokeWidth: 1.05627,
    fill: "none",
    strokeLinejoin: "bevel"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M146.14988,1.81548 C141.33188,0.70543 133.53288,0 124.79688,0 C116.06088,0 108.26188,0.70543 103.44388,1.81548 C93.61758,3.88273 85.88268,11.61758 83.81548,21.44388 C82.70548,26.26188 81.99998,34.06038 81.99998,42.79688 C81.99998,51.53338 82.70548,59.33188 83.81548,64.14988 C85.88268,73.97608 93.61748,81.71088 103.44388,83.77828 C108.26188,84.88828 116.05988,85.59378 124.79688,85.59378 C133.53388,85.59378 141.33188,84.88828 146.14988,83.77828 C155.97588,81.71098 163.71088,73.97618 165.77788,64.15008 C166.88788,59.33208 167.59388,51.53348 167.59388,42.79688 C167.59388,34.06028 166.88788,26.26168 165.77788,21.44368 C163.71088,11.61748 155.97588,3.88272 146.14988,1.81548 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2.59375,
    fill: "#FCDBD4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(83.296880, 1.296880)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-30",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-30)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.411600, -15.906781)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(30.447400, 41.622081)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-32",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.47,9.5166 C13.47,14.7735 10.455,19.0351 6.735,19.0351 C3.016,19.0351 0.001,14.7735 0.001,9.5166 C0.001,4.2597 3.016,-0.0019 6.735,-0.0019 C10.455,-0.0019 13.47,4.2597 13.47,9.5166 Z",
    id: "Path",
    fill: "#AE5848",
    mask: "url(#mask-32)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(30.447400, 41.622081)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-34",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.725,1.8987 C1.46,5.376 4.484,6.4273 8.448,4.7601 C9.087,9.5189 12.338,9.5189 15.183,10.0157 L12.338,-3.0649 L0.32,0.0004 L-0.725,1.8987 Z",
    id: "Path",
    fill: "#2F3030",
    mask: "url(#mask-34)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.8994,52.9624813 L33.1514,53.9750813 C33.1514,53.9750813 34.2544,57.4202813 36.3444,57.4202813 C38.4344,57.4202813 38.8994,52.9624813 38.8994,52.9624813 Z",
    id: "Path",
    stroke: "#843628",
    strokeWidth: 1.05627,
    fill: "none",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2284,36.6897813 C38.3774,28.8645813 32.5134,33.9450813 38.8994,43.8724813 C45.2864,53.7998813 51.3244,48.8945813 48.0464,39.4344813 C52.8574,50.2983813 57.6424,48.7880813 62.4134,39.5510813 C66.3604,56.8364813 79.3074,53.5661813 77.7404,35.2298813 C76.1724,16.8934413 60.7294,14.7717313 57.4204,25.1856813 C53.5304,15.6087813 41.8404,15.0832113 45.2284,36.6897813 Z",
    id: "Path",
    stroke: "none",
    fill: "#2F3030",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5464,14.5274313 L77.5134,17.8754613 C77.5134,17.8754613 83.3184,5.72911135 82.4674,4.95040135 C81.6154,4.17186135 78.8294,7.90916135 78.8294,7.90916135 C78.8294,7.90916135 80.7834,0.882181347 79.7384,0.259381347 C78.6934,-0.363618653 76.4294,6.31302135 76.4294,6.31302135 C76.4294,6.31302135 77.0674,0.259381347 76.0614,0.00618134705 C75.0554,-0.246718653 73.0424,7.34470135 73.0424,7.34470135 C73.0424,7.34470135 71.4174,2.94554135 70.3724,3.21796135 C68.9064,3.60040135 70.5464,14.5274313 70.5464,14.5274313 Z",
    id: "Path",
    stroke: "none",
    fill: "#AE5848",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(24.631089, 13.359906)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-36",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-36)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.001000, -0.000732)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0123114182,84.901307 L35.4943114,83.856807 L32.8013114,61.402207 L54.5143114,3.882007 C51.9743114,1.333707 48.4863114,0.241409 44.4453114,-7.21644966e-16 C36.5083114,19.715207 29.2193114,38.307807 25.5573114,50.610107 C25.5573114,50.610107 6.58631142,52.713507 3.10831142,54.035907 C-0.368688582,55.358407 0.0123114182,84.901307 0.0123114182,84.901307 Z",
    fill: "#AFA5EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1433114,47.186007 L6.39631142,49.828207 C6.39631142,49.828207 5.73031142,56.725007 12.6663114,57.691407 C22.7683114,59.098807 21.1433114,47.186007 21.1433114,47.186007 Z",
    fill: "#AE5848"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M29.4454,66.9259813 C26.9514,67.4948813 24.1224,67.9600813 20.3204,71.6390813 C16.5174,75.3180813 1.42108547e-14,89.5375813 1.42108547e-14,89.5375813 L7.0249,100.720381 C7.0249,100.720381 24.2104,82.4131813 26.3584,79.8436813 C28.5064,77.2743813 31.6404,66.4254813 29.4454,66.9259813 Z",
    id: "Path",
    stroke: "none",
    fill: "#AFA5EF",
    fillRule: "evenodd"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRolesModal);
export default __webpack_public_path__ + "static/media/roles-modal.edaa72b5f37dfd56f323de48c6e6c636.svg";
export { ForwardRef as ReactComponent };